export const fileToString = (file: File): Promise<string> => new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (readerError) => reject(readerError);
});

export const adaptFiles = async (contactId, files, multiple = false, metadataReferenceId = 'ClientDataDocument') => {
    const adaptFile = async (file) => {
        // eslint-disable-next-line no-useless-catch
        try {
            const { filename, name } = file;
            const fileString: string = await fileToString(file);
            const splits = fileString.split(';base64,');

            return {
                originalFilename: filename || name,
                retrieveFileAsName: filename || name,
                Filename: filename || name,
                ownerIds: [contactId],
                metadataReferenceId,
                file: splits[1],
            };
        } catch (error) {
            throw error;
        }
    };
    const filesAdapted = await Promise.all(await files.map(adaptFile));

    return multiple ? filesAdapted : filesAdapted?.[0];
};
